"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableHeader = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const Icon_1 = require("../../Icon");
const TableState_1 = require("../utils/TableState");
const utils_1 = require("../utils/utils");
const Css_1 = require("../../../Css");
const hooks_1 = require("../../../hooks");
const utils_2 = require("../../../utils");
const Loader_1 = require("../../Loader");
function ExpandableHeader(props) {
    const { title, column, minStickyLeftOffset, as } = props;
    const { tableState } = (0, react_1.useContext)(TableState_1.TableStateContext);
    const expandedColumnIds = (0, hooks_1.useComputed)(() => tableState.expandedColumnIds, [tableState]);
    const isExpanded = expandedColumnIds.includes(column.id);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    // Do not apply sticky styles when rendering as table. Currently the table does not properly respect column widths, causing the sticky offsets to be incorrect
    const applyStickyStyles = isExpanded && as !== "table";
    const { hoverProps, isHovered } = (0, hooks_1.useHover)({});
    return ((0, jsx_runtime_1.jsxs)("button", { ...hoverProps, css: Css_1.Css.df.xsMd.aic.jcsb.gap2.px1.hPx(32).mxPx(-8).w("calc(100% + 16px)").br4.lightBlue700.if(isHovered).bgGray100.$, onClick: async () => {
            if ((0, utils_2.isFunction)(column.expandColumns)) {
                setIsLoading(true);
                await tableState.loadExpandedColumns(column);
                setIsLoading(false);
            }
            // manually calling this as loadExpandedColumns does not toggle
            tableState.toggleExpandedColumn(column.id);
        }, "data-testid": "expandableColumn", children: [(0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.tl.lineClamp2
                    .if(applyStickyStyles)
                    .sticky.leftPx(minStickyLeftOffset + 12)
                    .pr2.mr2.bgWhite.z(utils_1.zIndices.expandableHeaderTitle)
                    .if(isHovered).bgGray100.$, children: title }), (0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.if(applyStickyStyles).sticky.rightPx(12).z(utils_1.zIndices.expandableHeaderIcon).$, children: isLoading ? (0, jsx_runtime_1.jsx)(Loader_1.Loader, { size: "xs" }) : (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: isExpanded ? "chevronLeft" : "chevronRight", inc: 2 }) })] }));
}
exports.ExpandableHeader = ExpandableHeader;
